export const ErrorBanner = ({ message }) => (
  <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
    {message}
  </div>
);

export const EmptyMessage = ({ message }) => (
  <p className="text-sm text-gray-500 italic">{message}</p>
);

export const TableSkeleton = ({ rows = 5, cols = 4 }) => (
  <div className="animate-pulse space-y-3">
    <div className="h-8 bg-gray-200 rounded" />
    {[...Array(rows)].map((_, i) => (
      <div key={i} className="grid gap-3" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
        {[...Array(cols)].map((__, j) => (
          <div key={j} className="h-5 bg-gray-100 rounded" />
        ))}
      </div>
    ))}
  </div>
);

export const ChartSkeleton = ({ height = 320 }) => (
  <div className="animate-pulse">
    <div className="h-4 w-1/3 bg-gray-200 rounded mb-6" />
    <div className="bg-gray-200 rounded" style={{ height }} />
  </div>
);
